import * as c from "./constant";

const initialState = {
  signedIn: false,
  accessDenied: false,
  serverError: "",
  user: {},
  showSessionExpiredModal: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case c.signedIn:
      return {
        ...state,
        signedIn: true
      };
    case c.accessDenied:
      return {
        ...state,
        accessDenied: true
      };
    case c.logout:
      return initialState;
    case c.serverError:
      return {
        ...state,
        serverError: action.payload
      };
    case c.user:
      return {
        ...state,
        serverError: "",
        user: action.payload
      };
    case c.showSessionExpiredModal:
      return {
        ...state,
        showSessionExpiredModal: action.payload
      };
    default:
      return state;
  }
};
